import type { TranslateCostProps } from "./translate-cost.type";

import { useTranslateCost } from "./translate-cost.hook";

const TranslateCost = ({ value, format }: TranslateCostProps) => {
  const { translateCost } = useTranslateCost();

  return translateCost(value, format);
};

export default TranslateCost;
